module.exports = __webpack_public_path__ + "img/album18_25.cb5ff7c3.jpg";